import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../../Layout/Layout";
import FooterCalendar from "../../Layout/FooterCalendar";
import { useCart } from "../../../Context/CartContext";

const BASE_URL = "https://ecom.cyberathon.com";

function PaymentPage() {
  const navigate = useNavigate();
const { setCartCount } = useCart();

  /* ================= USER / CART ================= */
  const userId = sessionStorage.getItem("userId");
  const cartToken = localStorage.getItem("cart_token");
  const billingId = localStorage.getItem("selected_billing_id");
  const couponId = localStorage.getItem("applied_coupon_id");

  /* ================= PAYMENT MODE ================= */
  const [paymentMode, setPaymentMode] = useState("Cash");

  /* ================= CART DATA ================= */
  const [cartItems, setCartItems] = useState([]);
  const [orderSummary, setOrderSummary] = useState({
    subtotal: "0.00",
    discount: "0.00",
    shipping: "0.00",
    grandTotal: "0.00",
  });

  const [loading, setLoading] = useState(false);

  /* ================= FETCH CART ================= */
  const fetchCart = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/index.php/Api/list_cart`,
        {
          user_id: userId ? userId : null,
          cart_token: userId ? null : cartToken,
        }
      );

      if (res.data.status === true || res.data.status === "true") {
        setCartItems(res.data.cart_items || []);
        setOrderSummary({
          subtotal: res.data.subtotal || "0.00",
          discount: res.data.discount || "0.00",
          shipping: res.data.shipping_total || "0.00",
          grandTotal: res.data.grand_total || "0.00",
        });
      }
    } catch (err) {
      console.error("Fetch cart error:", err);
    }
  };

  useEffect(() => {
    fetchCart();
  }, [userId, cartToken]);

  /* ================= PLACE ORDER ================= */
  const placeOrder = async () => {
    if (!userId && !cartToken) {
      alert("Cart not found");
      return;
    }

    if (!billingId) {
      alert("Please select address first");
      navigate("/Bill");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        user_id: userId ? userId : null,
        cart_token: userId ? null : cartToken,
        billing_id: billingId,
        payment_mode: paymentMode,
        coupon_id: couponId ? couponId : null
      };

      console.log("PLACE ORDER PAYLOAD:", payload);

      const res = await axios.post(
        `${BASE_URL}/index.php/Api/place_order`,
        payload
      );

      if (res.data.status === true || res.data.status === "true") {
        localStorage.removeItem("applied_coupon_id");
          setCartCount(0); 
        if (res.data.order_id) {
          localStorage.setItem("last_order_id", res.data.order_id);
          localStorage.removeItem("selected_billing_id");

          navigate("/order-confirm", {
            state: { order_id: res.data.order_id },
          });
        } else {
          alert("Order placed but order ID missing");
        }
      } else {
        alert(res.data.message || "Order failed");
      }
    } catch (err) {
      console.error("Place order error:", err);
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Layout />
      <div className="container my-5">
        <div className="row g-4">
          {/* ================= LEFT : PAYMENT ================= */}
          <div className="col-md-8">
            <div className="border p-3 rounded-2 mb-4 bg-light">
              <strong>Bank Offer</strong>
              <p className="mb-0">
                10% Instant Discount on Axis Bank Credit Card & EMI on min spend ₹3000
              </p>
            </div>

            <h5 className="fw-bold mb-3">Choose Payment Mode</h5>

            <div className="border rounded-2">
              <div className="p-3 border-bottom">
                <input
                  type="radio"
                  checked={paymentMode === "Cash"}
                  onChange={() => setPaymentMode("Cash")}
                />{" "}
                Cash On Delivery
              </div>

              <div className="p-3 border-bottom">
                <input
                  type="radio"
                  checked={paymentMode === "Card"}
                  onChange={() => setPaymentMode("Card")}
                />{" "}
                Prepaid
              </div>
            </div>
          </div>

          {/* ================= RIGHT : SUMMARY ================= */}
          <div className="col-md-4">
            <div className="border p-4 rounded-2 shadow-sm">
              <h6 className="fw-bold mb-3">Order Summary</h6>

              {cartItems.map((item) => (
                <div
                  key={item.cart_id}
                  className="d-flex justify-content-between mb-2 small"
                >
                  <span>{item.Product_name}</span>
                  <span>
                    {item.cart_qty} × ₹{item.current_price}
                  </span>
                </div>
              ))}

              <hr />

              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal</span>
                <span>₹{orderSummary.subtotal}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span>Shipping</span>
                <span>₹{orderSummary.shipping}</span>
              </div>

              {parseFloat(orderSummary.discount.replace(/,/g, '')) > 0 && (
                <div className="d-flex justify-content-between mb-2 text-success">
                  <span>Discount</span>
                  <span>- ₹{orderSummary.discount}</span>
                </div>
              )}

              <hr />

              <div className="fw-bold d-flex justify-content-between mb-3">
                <span>Total</span>
                <span>₹{orderSummary.grandTotal}</span>
              </div>

              <button
                className="w-100 py-2 border-0 rounded-2 fw-bold text-white"
                style={{ backgroundColor: "#24aeb1" }}
                onClick={placeOrder}
                disabled={loading}
              >
                {loading ? "PLACING ORDER..." : "PLACE ORDER"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <FooterCalendar />
    </>
  );
}

export default PaymentPage;